/**
 * The REGISTERED sidebar sections (#1798).
 *
 * An `as const` map whose derived union closes `menu.section` at compile time:
 * an action naming a section that does not exist fails to build instead of
 * silently rendering into nothing. This is the §3 principle-6 exemption for
 * `section` being paid off — the ids below are a closed set, not free strings.
 *
 * Ids only. Which label a section carries, whether it is admin-only and in what
 * order the sections stack are the sidebar's own business (#1775 / #1777, the
 * v4 shell of #2476, and the regrouping by function of #2511);
 * this file must not become a second place where the menu is grouped.
 */
export const MENU_SECTION = {
  /** 工作台 — how it is going overall: the overview, the inbox, analytics. */
  workbench: 'workbench',
  /** 配送 — the delivery work and its resources: the console, jobs, drivers. */
  delivery: 'delivery',
  /** 订单与商品 — the sales-side data: orders, customers, products. */
  ordersProducts: 'ordersProducts',
  /** 厨房管理 — the kitchen catalog, menu plans, stock and procurement (#2476). */
  kitchen: 'kitchen',
  /** 设置 — admin-role settings: delivery flow, integrations, members. */
  management: 'management',
  /** 管理 — admin-role oversight, placed after 设置: the audit ledgers and webhooks. */
  admin: 'admin',
  /** Documentation, linked beside the user block at the foot of the sidebar. */
  docs: 'docs',
} as const;

export type MenuSection = (typeof MENU_SECTION)[keyof typeof MENU_SECTION];
